import { render, staticRenderFns } from "./SceneCard.vue?vue&type=template&id=4d19a1de&scoped=true"
import script from "./SceneCard.vue?vue&type=script&lang=js"
export * from "./SceneCard.vue?vue&type=script&lang=js"
import style0 from "./SceneCard.vue?vue&type=style&index=0&id=4d19a1de&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d19a1de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d19a1de')) {
      api.createRecord('4d19a1de', component.options)
    } else {
      api.reload('4d19a1de', component.options)
    }
    module.hot.accept("./SceneCard.vue?vue&type=template&id=4d19a1de&scoped=true", function () {
      api.rerender('4d19a1de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/investment-research/components/SceneCard.vue"
export default component.exports